import React, { Component } from "react";
import $ from "jquery";
import { imageProvider } from "../../../../providers/Image.Provider";
import LoadingSpinner from "../../../../partials/loading";
import { ReadData } from "../../../../providers/Patient.Provider";
import Select from "react-dropdown-select";
import options from "./data.json";

class NewBodyMap extends Component {
    injuryRef = React.createRef();
    descRef = React.createRef();

    state = { imagePath: "" };

    patient = ReadData();
    componentDidMount() {
        setTimeout(() => {
            // initialize the canvas
            this.Init();
            // Draw image on the canvas
            // this.Start();
        }, 300);
    }

    UNSAFE_componentWillMount() {
        if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
                value: function (callback, type, quality) {
                    var binStr = atob(this.toDataURL(type, quality).split(",")[1]),
                        len = binStr.length,
                        arr = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        arr[i] = binStr.charCodeAt(i);
                    }
                    callback(new Blob([arr], { type: type || "image/png" }));
                },
            });
        }
    }

    state = { color: "#2bbd7a", loading: false };
    ctx;
    mousePressed = false;
    lastX = 0;
    lastY = 0;

    wy = 2;
    colors = ["#2bbd7a", "#dc3545", "#0e70c7", "#fa5571", "#913bd6"];

    Start = () => {
        const img = document.getElementById("canvasImg");
        this.ctx.drawImage(img, 0, 0, 800, 380);
    };
    Init = () => {
        this.ctx = document.getElementById("playground").getContext("2d");
        const _ = this;
        $("#playground").mousedown(function (e) {
            _.mousePressed = true;
            _.Draw(e.pageX - $(this).offset().left, e.pageY - $(this).offset().top, false);
        });

        $("#playground").mousemove(function (e) {
            if (_.mousePressed) {
                _.Draw(e.pageX - $(this).offset().left, e.pageY - $(this).offset().top, true);
            }
        });

        $("#playground").mouseup(function (e) {
            _.mousePressed = false;
        });
        $("#playground").mouseleave(function (e) {
            _.mousePressed = false;
        });
    };
    Draw = (x, y, isDown) => {
        if (isDown) {
            this.ctx.beginPath();
            this.ctx.strokeStyle = this.state.color;
            this.ctx.lineWidth = this.wy;
            this.ctx.lineJoin = "round";
            this.ctx.moveTo(this.lastX, this.lastY);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            this.ctx.stroke();
        }
        this.lastX = x;
        this.lastY = y;
    };

    onSelectImage = (path) => {
        if (path) {
            this.setState({ imagePath: path });
            // document.getElementById("canvasImg").src = this.state.imagePath;
            // setTimeout(() => {
            //     this.Start();
            // }, 100);
        }
    };
    render() {
        const { color } = this.state;
        return (
            <div className="row justify-content-center">
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                {this.patient.gender.toLowerCase() === "male" && (
                                    <td style={{ width: "80%" }}>
                                        <h5>Male Body</h5>
                                        <Select
                                            onChange={(items) => this.onSelectImage(items[0].value)}
                                            separator
                                            multi={false}
                                            className="input-height"
                                            placeholder="- Please Select -"
                                            options={options.male}
                                        />
                                    </td>
                                )}
                                {this.patient.gender.toLowerCase() === "female" && (
                                    <td style={{ width: "80%" }}>
                                        <h5>Female Body</h5>
                                        <Select
                                            onChange={(items) => this.onSelectImage(items[0].value)}
                                            separator
                                            multi={false}
                                            className="input-height"
                                            placeholder="- Please Select -"
                                            options={options.female}
                                        />
                                    </td>
                                )}
                                {/* <td style={{ width: "45%" }}>
                                    <h5>Both (Male & Female)</h5>
                                    <Select
                                        onChange={(items) => this.onSelectImage(items[0].value)}
                                        separator
                                        placeholder="- Please Select -"
                                        multi={false}
                                        className="input-height"
                                        options={options.both}
                                    />
                                </td> */}
                                <td style={{ width: "20%" }}>
                                    <h5>View/Reset</h5>
                                    <button onClick={this.Reset} title="View" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                                        View Image
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-10">
                    <canvas width="800" height="500" id="playground"></canvas>
                    <img id="canvasImg" width="620" src={this.state.imagePath} alt="Preview" style={{ display: "none" }} />
                </div>

                <div className="col-12">
                    <form
                        onSubmit={async (event) => {
                            event.preventDefault();
                            // upload image here
                            this.setState({ loading: true });
                            document.getElementById("playground").toBlob(
                                async (blob) => {
                                    const cb = await imageProvider.Upload(this.props.id + `-${this.injuryRef.current.value}.png`, blob);
                                    this.props.onSubmit({
                                        injuryType: this.injuryRef.current.value,
                                        description: this.descRef.current.value,
                                        photo: cb.path,
                                    });
                                },
                                "image/png",
                                0.9
                            );
                            this.setState({ loading: false });
                        }}
                    >
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td className="text-center">
                                        <h5>Active Color</h5>

                                        <i style={{ color }} className="material-icons">
                                            edit
                                        </i>
                                    </td>
                                    <td>
                                        <h5>Choose Color</h5>
                                        {this.colors.map((item, idx) => (
                                            <button
                                                key={idx}
                                                type="button"
                                                onClick={() => this.setState({ color: item })}
                                                className={`mdl-button  mdl-button--icon margin-right-10 ${item === color ? "btn-default" : ""}`}
                                            >
                                                <i style={{ color: item }} className="material-icons">
                                                    color_lens
                                                </i>
                                            </button>
                                        ))}
                                    </td>

                                    <td>
                                        <label htmlFor="injury-results">Injury Type *</label>
                                        <input type="injury" className="form-control input-height" id="injury-results" required ref={this.injuryRef} aria-describedby="injury-results" />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="4">
                                        <label htmlFor="description-id">Description</label>
                                        <textarea
                                            name="description-id"
                                            id="description-id"
                                            className="form-control form-control-textarea"
                                            rows="3"
                                            ref={this.descRef}
                                            placeholder="enter description"
                                        ></textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="form-group m-t-20">
                            <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 btn-circle btn-success">
                                Save
                                <i className="material-icons">keyboard_arrow_right</i>
                            </button>
                        </div>
                    </form>
                    <LoadingSpinner loading={this.state.loading} bar={true} />
                </div>
            </div>
        );
    }

    Reset = () => {
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        document.getElementById("canvasImg").src = this.state.imagePath;
        this.Start();
    };
}

export default NewBodyMap;
